<cui-breadcrumb>
    <ng-container *ngIf="PageBreadcrumb">
        <ng-container *ngIf="Global.checkIsArray(PageBreadcrumb); else textBreadcrumbBlock">
            <li class="breadcrumb-item">
                <a routerLink="/home"><span>Home</span></a>
            </li>
            <ng-container *ngFor="let item of PageBreadcrumb">
                <li class="breadcrumb-item" [ngClass]="{'active': item.active == true }">
                    <ng-container *ngIf="item.url; else noUrlItem">
                        <a routerLink="{{ item.url }}"><span>{{ item.name }}</span></a>
                    </ng-container>
                    <ng-template #noUrlItem>
                        <span>{{ item.name }}</span>
                    </ng-template>
                </li>
            </ng-container>
        </ng-container>
        <ng-template #textBreadcrumbBlock>
            <li class="breadcrumb-item">
                <a routerLink="/home"><span>Home</span></a>
            </li>
            <li class="breadcrumb-item active">
                <span>{{ PageBreadcrumb }}</span>
            </li>
        </ng-template>

        <!-- <li class="breadcrumb-item">
            <a href="">Home</a>
        </li>
        <li class="breadcrumb-item active">
            <span>Home</span>
        </li> -->
    </ng-container>


    <li class="breadcrumb-menu d-md-down-none" *ngIf="PageTitle" [innerHTML]="PageTitle"></li>
</cui-breadcrumb>